import 'assets/styles/main.css'
import 'react-toastify/dist/ReactToastify.css'
import 'i18n/config'
import 'globals.css'
import 'react-tooltip/dist/react-tooltip.css'

import App from 'App'
import { ThemeProvider } from 'contexts/theme-context'
import GlobalStyles from 'GlobalStyles'
import ClientErrorPage from 'pages/ClientErrorPage'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'
import TagManager from 'react-gtm-module'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { persistor, store } from 'redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import { initializeSentry } from 'sentry-integration'
import { getSourceType } from 'utils/getSourceType'

const MODE = import.meta.env.MODE

if (MODE === 'production') {
  TagManager.initialize({
    gtmId: 'GTM-KH4FN5W',
    dataLayer: {
      userId: '001',
      userProject: 'project'
    }
  })
  initializeSentry()
}

if (MODE === 'development' || MODE === 'preprod') {
  console.log('Source type: ', getSourceType())
  import('eruda').then(eruda => eruda.default.init())
}

const container = document.getElementById('root') as HTMLElement

const root = ReactDOM.createRoot(container)

root.render(
  <React.StrictMode>
    <ThemeProvider initialTheme='dark'>
      <ToastContainer position='top-right' autoClose={5000} theme='light' />
      <GlobalStyles />
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={null}>
          <ErrorBoundary
            FallbackComponent={ClientErrorPage}
            onReset={() => {
              console.log('Reset Error')
            }}
          >
            <App />
          </ErrorBoundary>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
)
